import { useTranslation } from "react-i18next";

const ProtectionModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  if (!open) return null;

  const items = [
    { icon: "fa-check-circle", text: t("km_unlimited"), color: "green" },
    { icon: "fa-check-circle", text: t("own_risk"), color: "green" },
    { icon: "fa-check-circle", text: t("damage_cover"), color: "green" },
    { icon: "fa-times-circle", text: t("glass_tire"), color: "gray", isDanger: true },
    { icon: "fa-times-circle", text: t("interior_protect"), color: "gray", isDanger: true },
    {
      icon: "fa-times-circle",
      text: t("not_included_towing"),
      color: "gray",
      isDanger: true,
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">{t("basic_title")}</h2>
            <p className="mt-1 text-slate-600">{t("basic_subtitle")}</p>
          </div>
          <button onClick={onClose} className="p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100">
            <i className="text-xl fa-solid fa-xmark" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-4 p-4 border rounded-lg ${
                item.isDanger ? "bg-red-50 border-red-200" : `bg-${item.color}-50 border-${item.color}-200`
              }`}
            >
              <div className="flex items-center justify-center w-12 h-12 bg-white border rounded-lg shadow-sm">
                <i className={`fa-solid ${item.icon} text-${item.color}-600 text-lg`} />
              </div>
              <p className="text-slate-700">{item.text}</p>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-slate-200">
          <button
            onClick={onClose}
            className="w-full py-3 bg-[#f5272b] hover:bg-red-700 text-white font-bold rounded-lg shadow-lg"
          >
            {t("got_it")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProtectionModal;
